module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/monitoringZivotnihoProstredi-922b2a7c99ca97d5bb27575ff7608109.svg";